import { ref } from 'vue'
import { defineStore } from 'pinia'
import { SCREEN_BREAKPOINTS } from '@/shared/config/constants'

export type ScreenSize = 'lg' | 'md'

export const useScreenStore = defineStore('screens', () => {
  const screenSize = ref<ScreenSize>('lg')

  const setScreenSize = (width: number) => {
    const currentSize = screenSize.value
    let newSize: ScreenSize

    // if (width < SCREEN_BREAKPOINTS.SM) {
    //   newSize = 'sm'
    // } else
    if (width < SCREEN_BREAKPOINTS.MD) {
      newSize = 'md'
    } else {
      newSize = 'lg'
    }

    if (currentSize !== newSize) {
      screenSize.value = newSize
      console.log('Screen size changed', { width, newSize })
    }
  }

  return {
    screenSize,
    setScreenSize
  }
})
